import React from 'react';
import './Contact.css';
import contactImg from '../Assets/contact.jpg';
import { FiMail, FiPhone } from 'react-icons/fi';

const Contact = () => {
    return (
        <section className="contact-section" id="contact">
            <h1>Contact <span>Us</span></h1>
            <div className="contact-wrapper">
                {/* Left side: Contact Info + Map */}
                <div className="contact-left">
                    <h2>Let’s Talk</h2>
                    <p className="contact-intro">
                        We'd love to hear from you. Reach out anytime.
                    </p>
                    <div className="contact-item">
                        <FiMail />
                        <a href="mailto:info@nexorastudio.net">info@nexorastudio.net</a>
                    </div>
                    <div className="contact-item">
                        <FiPhone />
                        <a href="tel:+17789969060">+1 (778) 996 9060</a>
                    </div>
                    <div className="contact-item">
                        <FiPhone />
                        <a href="tel:+17789303838">+1 (778) 930 3838</a>
                    </div>

                    <div className="map-container">
                        <iframe
                            title="Vancouver Location"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2602.6668690063957!2d-123.12164478440014!3d49.28272927933106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54867179a18b1b17%3A0x4c3d13f17b8f5bd6!2sVancouver%2C%20BC%2C%20Canada!5e0!3m2!1sen!2sus!4v1685256699327!5m2!1sen!2sus"
                            width="100%"
                            height="300"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>

                {/* Right side: Image */}
                <div className="contact-right">
                    <div
                        className="contact-bg"
                        style={{ backgroundImage: `url(${contactImg})` }}
                    ></div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
